import { useRouteError } from "react-router-dom";

const Error = () => {
    const error = useRouteError();
    console.error(error);
    return (
        <div>Opps! Something went wrong.</div>
    )
}


export default Error;